import gql from "graphql-tag";

const getRouteBasicInfo = gql`
query getRouteBasicInfo($routeID: Int!) {
  getRouteBasicInfo(routeID: $routeID) {
    routeCode
  }
}
`
export { getRouteBasicInfo }